import { render, staticRenderFns } from "./my-account.vue?vue&type=template&id=90d6ccc8&scoped=true&"
import script from "./my-account.vue?vue&type=script&lang=js&"
export * from "./my-account.vue?vue&type=script&lang=js&"
import style0 from "./my-account.vue?vue&type=style&index=0&id=90d6ccc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../MultiSiteClient/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d6ccc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../MultiSiteClient/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VRow})
